
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M445.502 180.03C443.881 115.681 391.273 64 326.571 64c-37.896 0-71.633 17.747-93.427 45.366-12.221-15.799-31.345-25.98-52.854-25.98-36.905 0-66.821 29.938-66.821 66.861 0 3.218.24 6.38.682 9.477a97.28 97.28 0 00-17.285-1.569C43.367 158.154 0 201.548 0 255.076 0 308.607 43.367 352 96.865 352h49.88L256 461.255 365.255 352h59.741v-.006c48.069-.092 87.004-39.105 87.004-87.223 0-41.045-28.339-75.45-66.498-84.741zM256 416l-96-96h64v-96h64v96h64l-96 96z"}})])
          )
        }
      }
    